<template lang="pug">
v-expansion-panels#shape-layer-editor(popout)
  name-editor(:layer="layer")
  dimension-editor(:dimensions="dimensions" :size="templateSize")
  v-expansion-panel
    v-expansion-panel-header.shape-settings Shape
    v-expansion-panel-content
      v-card
        v-card-text
          v-select.shape-select(v-model="shape" :items="shapeOptions" label="Shape" dense outlined)
            magic-property-input-talker(slot="prepend-inner" :layer="layer" attributeName="shape")
  v-expansion-panel
    v-expansion-panel-header.stroke-settings Stroke
    v-expansion-panel-content
      v-card
        v-card-text
          v-layout
            v-flex(shrink)
              magic-property-input-talker(slot="prepend-inner" :layer="layer" attributeName="strokePresent")
            v-flex
              v-checkbox(color="primary" v-model="strokePresent" label="Stroke?")
          v-text-field(v-if="strokePresent" label="Stroke Width" type="number" step="0.01" v-model.number="strokeWidth" dense outlined)
            magic-property-input-talker(slot="prepend-inner" :layer="layer" attributeName="strokeWidth")
          v-layout
            v-flex(shrink)
              magic-property-input-talker(slot="prepend-inner" :layer="layer" attributeName="strokeColor")
            v-flex
              color-picker(v-if="strokePresent" label="Stroke Color" v-model="strokeColor")
  v-expansion-panel
    v-expansion-panel-header.fill-settings Fill
    v-expansion-panel-content
      v-card
        v-card-text
          v-layout
            v-flex(shrink)
              magic-property-input-talker(slot="prepend-inner" :layer="layer" attributeName="fillPresent")
            v-flex
              v-checkbox(color="primary" v-model="fillPresent" label="Fill?")
          v-layout
            v-flex(shrink)
              magic-property-input-talker(slot="prepend-inner" :layer="layer" attributeName="fillColor")
            v-flex
              color-picker(v-if="fillPresent" label="Fill Color" v-model="fillColor" filled)
  v-expansion-panel(v-if="shape === 'rectangle'")
    v-expansion-panel-header Corner Insets
    v-expansion-panel-content
      v-card
        v-card-text
          p.mb-0 Adjust corners to create non-rectangular shapes.
          v-btn(small text color="primary" @click="resetCornerDefaults") Reset to defaults
          v-layout(align-center)
            v-slider.flex-grow-1(
              v-model="cornerTopLeft"
              label="Top Left"
              min="0"
              max="1"
              step="0.01"
              thumb-label
              filled
              hide-details
            )
            v-text-field(
              v-model="sliderInputs.cornerTopLeft"
              dense
              outlined
              hide-details
              style="max-width: 76px; margin-left: 12px; flex-shrink: 0"
              @keydown.enter.prevent="commitSliderInput('cornerTopLeft', 0, 1, 2)"
              @blur="commitSliderInput('cornerTopLeft', 0, 1, 2)"
            )
          v-layout(align-center)
            v-slider.flex-grow-1(
              v-model="cornerTopRight"
              label="Top Right"
              min="0"
              max="1"
              step="0.01"
              thumb-label
              filled
              hide-details
            )
            v-text-field(
              v-model="sliderInputs.cornerTopRight"
              dense
              outlined
              hide-details
              style="max-width: 76px; margin-left: 12px; flex-shrink: 0"
              @keydown.enter.prevent="commitSliderInput('cornerTopRight', 0, 1, 2)"
              @blur="commitSliderInput('cornerTopRight', 0, 1, 2)"
            )
          v-layout(align-center)
            v-slider.flex-grow-1(
              v-model="cornerBottomLeft"
              label="Bottom Left"
              min="0"
              max="1"
              step="0.01"
              thumb-label
              filled
              hide-details
            )
            v-text-field(
              v-model="sliderInputs.cornerBottomLeft"
              dense
              outlined
              hide-details
              style="max-width: 76px; margin-left: 12px; flex-shrink: 0"
              @keydown.enter.prevent="commitSliderInput('cornerBottomLeft', 0, 1, 2)"
              @blur="commitSliderInput('cornerBottomLeft', 0, 1, 2)"
            )
          v-layout(align-center)
            v-slider.flex-grow-1(
              v-model="cornerBottomRight"
              label="Bottom Right"
              min="0"
              max="1"
              step="0.01"
              thumb-label
              filled
              hide-details
            )
            v-text-field(
              v-model="sliderInputs.cornerBottomRight"
              dense
              outlined
              hide-details
              style="max-width: 76px; margin-left: 12px; flex-shrink: 0"
              @keydown.enter.prevent="commitSliderInput('cornerBottomRight', 0, 1, 2)"
              @blur="commitSliderInput('cornerBottomRight', 0, 1, 2)"
            )
  v-expansion-panel
    v-expansion-panel-header Opacity
    v-expansion-panel-content
      v-card
        v-card-text
          v-layout(align-center)
            v-slider.flex-grow-1(
              v-model="opacity"
              min="0"
              max="1"
              step="0.01"
              thumb-label
              filled
              hide-details
            )
            v-text-field(
              v-model="sliderInputs.opacity"
              dense
              outlined
              hide-details
              style="max-width: 76px; margin-left: 12px; flex-shrink: 0"
              @keydown.enter.prevent="commitSliderInput('opacity', 0, 1, 2)"
              @blur="commitSliderInput('opacity', 0, 1, 2)"
            )
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import { computedVModelUpdateAll } from '../../util/component_helper'
  import NameEditor from './NameEditor.vue'
  import DimensionEditor from './DimensionEditor.vue'
  import ColorPicker from '../../shared/ColorPicker.vue'
  import MagicPropertyInputTalker from '../../source/MagicPropertyInputTalker.vue'
  const shapeOptions = [
    { value: "rectangle", text: "Rectangle" },
    { value: "roundedRectangle", text: "Rounded Rectangle" },
    { value: "ellipse", text: "Ellipse" },
  ]
  export default {
    props: ["layer"],
    components: {
      NameEditor,
      DimensionEditor,
      ColorPicker,
      MagicPropertyInputTalker
    },
    data() {
      return {
        shapeOptions,
        sliderInputs: {
          opacity: String(this.layer.opacity ?? 1),
          cornerTopLeft: String(this.layer.cornerTopLeft ?? 0),
          cornerTopRight: String(this.layer.cornerTopRight ?? 0),
          cornerBottomLeft: String(this.layer.cornerBottomLeft ?? 0),
          cornerBottomRight: String(this.layer.cornerBottomRight ?? 0),
        }
      }
    },
    computed: {
      ...mapGetters(["getLayerDimensions", "findTemplateByLayerId"]),
      dimensions() { return this.getLayerDimensions(this.layer) },
      templateSize() {
        const template = this.findTemplateByLayerId(this.layer.id)
        return template && template.size
      },
      ...computedVModelUpdateAll("layer", "patchLayer", [
        "shape",
        "strokePresent",
        "strokeWidth",
        "strokeColor",
        "fillPresent",
        "fillColor",
        "cornerTopLeft",
        "cornerTopRight",
        "cornerBottomLeft",
        "cornerBottomRight",
        "opacity",
      ])
    },
    methods: {
      ...mapActions(["patchLayer"]),

      resetCornerDefaults() {
        this.$store.dispatch('patchLayer', {
          id: this.layer.id,
          cornerTopLeft: 0,
          cornerTopRight: 0,
          cornerBottomLeft: 0,
          cornerBottomRight: 0
        })
      },

      commitSliderInput(prop, min, max, decimals) {
        const parsed = parseFloat(this.sliderInputs[prop])
        if (!isNaN(parsed)) {
          const clamped = Math.min(max, Math.max(min, parsed))
          const rounded = parseFloat(clamped.toFixed(decimals))
          this[prop] = rounded
          this.sliderInputs[prop] = String(rounded)
        } else {
          this.sliderInputs[prop] = String(this[prop])
        }
      },
    },

    watch: {
      opacity(val) { this.sliderInputs.opacity = String(val) },
      cornerTopLeft(val) { this.sliderInputs.cornerTopLeft = String(val) },
      cornerTopRight(val) { this.sliderInputs.cornerTopRight = String(val) },
      cornerBottomLeft(val) { this.sliderInputs.cornerBottomLeft = String(val) },
      cornerBottomRight(val) { this.sliderInputs.cornerBottomRight = String(val) },
    }
  }
</script>